import React from 'react';

/** Numéros de page compacts : 1 … 4 5 6 … 29. */
function numeros(page, pages) {
  const garder = new Set([1, pages, page - 1, page, page + 1]);
  const sortie = [];
  let precedent = 0;
  for (let n = 1; n <= pages; n += 1) {
    if (!garder.has(n)) continue;
    if (n - precedent > 1) sortie.push('…');
    sortie.push(n);
    precedent = n;
  }
  return sortie;
}

export default function Pagination({ page, pages, onPage }) {
  if (!pages || pages <= 1) return null;
  return (
    <nav className="zk-aff-pagination" aria-label="Pages de résultats">
      <button type="button" onClick={() => onPage(page - 1)} disabled={page <= 1} aria-label="Page précédente">‹</button>
      {numeros(page, pages).map((n, i) => (n === '…' ? (
        <span key={`e${i}`} aria-hidden="true">…</span>
      ) : (
        <button
          key={n}
          type="button"
          onClick={() => onPage(n)}
          aria-current={n === page ? 'page' : undefined}
          className={n === page ? 'on' : ''}
        >
          {n}
        </button>
      )))}
      <button type="button" onClick={() => onPage(page + 1)} disabled={page >= pages} aria-label="Page suivante">›</button>
    </nav>
  );
}
